module.exports = __webpack_public_path__ + "static/media/peacock-avatar-real.4069da86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/peacock-avatar-real.png
// module id = 615
// module chunks = 0